import React from 'react';
import styled from 'styled-components';

const ProtocolSectionContainer = styled.div`
  background: #f7f7f7;
`;

const Content = styled.div`
  display: flex;
  position: relative;
  height: 640px;
  max-width: 666px;
  margin: 0 auto;

  @media screen and (max-width: 640px) {
    height: 280px;
  }
`;

const TextContainer = styled.div`
  position: relative;
  width: 40%;

  @media screen and (max-width: 768px) {
    left: 47px;
  }

  @media screen and (max-width: 640px) {
    max-width: 280px;
  }
`;

const Label = styled.div`
  width: 100%;
  display: flex;
  color: #7d7d7d;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.32px;

  &.wallet {
    position: absolute;
    top: 144px;

    @media screen and (max-width: 768px) {
      top: 105px;
    }

    @media screen and (max-width: 640px) {
      top: 54px;
    }
  }

  &.legal-entity {
    position: absolute;
    top: 274px;

    @media screen and (max-width: 768px) {
      top: 216px;
    }

    @media screen and (max-width: 640px) {
      top: 103px;
    }
  }

  &.assets {
    position: absolute;
    top: 394px;

    @media screen and (max-width: 768px) {
      top: 304px;
    }

    @media screen and (max-width: 640px) {
      top: 155px;
    }
  }
`;

const Line = styled.div`
  background: #b0b0b0;
  flex: 1;
  height: 1px;
  position: relative;
  top: 8px;
  margin: 0 10px;
`;

const ImgContainer = styled.div`
  position: relative;
  height: inherit;
  width: 70%;

  @media screen and (max-width: 640px) {
    width: 60%;
  }
`;

const Img = styled.img`
  display: inline;

  &.wallet {
    width: 100%;
    height: 303px;
    position: absolute;
    z-index: 2;
    opacity: 0.95;

    @media screen and (max-width: 768px) {
      height: 223px;
    }

    @media screen and (max-width: 640px) {
      height: 123px;
    }
  }

  &.legal-entity {
    width: 100%;
    height: 298px;
    top: 130px;
    position: absolute;
    z-index: 1;
    opacity: 0.89;

    @media screen and (max-width: 768px) {
      height: 218px;
      top: 110px;
    }

    @media screen and (max-width: 640px) {
      top: 52px;
      height: 118px;
    }
  }

  &.assets {
    width: 100%;
    height: 299px;
    top: 250px;
    position: absolute;
    z-index: 0;
    opacity: 0.95;

    @media screen and (max-width: 768px) {
      height: 219px;
      top: 200px;
    }

    @media screen and (max-width: 640px) {
      height: 119px;
      top: 104px;
    }
  }

  &.wallet,
  &.legal-entity,
  &.assets {
    @media screen and (max-width: 868px) {
      display: block;
    }
  }
`;

function ProtocolSection({ input }) {
  return (
    <ProtocolSectionContainer>
      <Content>
        <TextContainer>
          <Label className="wallet">
            <div>{input.primary.top_label.text}</div>
            <Line />
          </Label>
          <Label className="legal-entity">
            <div>{input.primary.middle_label.text}</div>
            <Line />
          </Label>
          <Label className="assets">
            <div>{input.primary.bottom_label.text}</div>
            <Line />
          </Label>
        </TextContainer>
        <ImgContainer>
          <Img
            src={input.primary.top_image.url}
            alt="TrustToken wallet"
            className="wallet"
          />
          <Img
            src={input.primary.middle_image.url}
            alt="TrustToken wallet"
            className="legal-entity"
          />
          <Img
            src={input.primary.bottom_image.url}
            alt="TrustToken wallet"
            className="assets"
          />
        </ImgContainer>
      </Content>
    </ProtocolSectionContainer>
  );
}

export { ProtocolSection };
